import { createSlice } from '@reduxjs/toolkit'
import { IUser } from 'store/types';

// Slice
const slice = createSlice({
  name: 'user',
  initialState: {
    user: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
    },
    logoutSuccess: (state, action) =>  {
      state.user = null;
    },
  },
});
export default slice.reducer
// Actions
const { loginSuccess, logoutSuccess } = slice.actions
export const login = ({ username }: IUser) => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
  try {
    // const res = await api.post('/api/auth/login/', { username, password })
    dispatch(loginSuccess({username}));
  } catch (e: any) {
    return console.error(e.message);
  }
}
export const logout = () => async (dispatch: (arg0: { payload: any; type: string; }) => any) => {
  try {
  
    return dispatch(logoutSuccess(''))
  } catch (e: any) {
    return console.error(e.message);
  }
}